import React from 'react';

const TabToggle = ({ options, activeValue, onChange }) => {
  return (
    <div className="inline-flex rounded-full bg-gray-100 p-1 shadow-sm">
      {options.map((option) => {
        const isActive = activeValue === option.value;
        return (
          <button
            key={option.value}
            type="button"
            onClick={() => onChange(option.value)}
            className={`px-4 py-2 rounded-full text-sm font-semibold transition ${
              isActive
                ? 'bg-white text-gray-900 shadow-sm'
                : 'text-gray-600 hover:bg-gray-200'
            }`}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
};

export default TabToggle;
